import UserPaymentReadinessStatus from "./UserPaymentReadinessStatus";

export default UserPaymentReadinessStatus;
